/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_Page_Find_LeadInputs */

const en_how_page_find_lead = /** @type {(inputs: How_Page_Find_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`People with free time, close to you.`)
};

const pl_how_page_find_lead = /** @type {(inputs: How_Page_Find_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ludzie z wolnym czasem, blisko Ciebie.`)
};

/**
* | output |
* | --- |
* | "People with free time, close to you." |
*
* @param {How_Page_Find_LeadInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const how_page_find_lead = /** @type {((inputs?: How_Page_Find_LeadInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_Page_Find_LeadInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_how_page_find_lead(inputs)
	return en_how_page_find_lead(inputs)
});